import React, { Component } from 'react'

export default class WorksUltimiMiracoli extends Component {
  render() {
    return (
 <div class="modal" id="worksultimimiracoli" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
          <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
            <div class="modal-header">
                <h5 class="modal-title"><strong>&quot;ULTIMI MIRACOLI.&quot; </strong>(Otto racconti): <em>Ediz. PeQuod 2022 <br /> (distribuzione: Messaggerie. Codice: 9788860682123)</em></h5>
            </div>
            <div class="modal-body p-4" id="result">
                   

            <div align="left">

<table border="0"  cellpadding="20">
  <tr colspan="1" width="100%">
  </tr>
  <tr width="100%">

<td width="50%">


<br/> <br/>

        
<div className="desc">
										<p>I protagonisti di queste storie, antieroi dei nostri giorni, devono affrontare momenti cruciali o nodi irrisolti e nel contempo superare le proprie fragilità. Sono sospesi fra occasioni mancate e attese rivincite, mentre il destino prepara in segreto i suoi agguati. Un uomo già adulto non sa più chi sia il proprio vero padre. Un altro, in doloroso conflitto con la figlia, vede messa in crisi la scelta su cui ha fondato la propria esistenza. Due sorelle difendono la loro storica libreria, mentre un giovane bibliotecario vuole risolvere l’enigma di un messaggio di soccorso lasciato in un volume. </p>


										<p>Con una scrittura asciutta e limpida, che rivela più di quanto dice, vengono messe in luce speranze e ossessioni, solitudini e intese profonde, come quella che nasce fra un assistente sociale e l’anziano invalido che un tempo fu il suo professore. Sotto la superficie della realtà preme una tensione che prelude a svolte inaspettate, per il lettore e per gli stessi protagonisti, accomunati dalla volontà di non arrendersi, dalla tenace ricerca di un varco salvifico. Di un ultimo miracolo possibile, come quello che illumina una coppia di profughi in una toccante natività odierna. </p>

									</div>
<br/>

<strong>ne hanno scritto:</strong> <br/><br/>

<ul>
<li><a href="rec/ultimimiracoli/Avvenire.pdf" target="_blank" >Roberto Carnero, Avvenire, 10.6.2022</a></li>
<li><a href="rec/ultimimiracoli/Corriere_Romagna.pdf" target="_blank" >Jennifer Fratti, Corriere Romagna, 12.6.2022</a></li>
<li><a href="rec/ultimimiracoli/Adige.pdf" target="_blank" >Luigi Longhi, l’Adige, 24.5.2022</a></li>
<li>a.g. il Tirreno, 28.5.2022</li>
<li>nf Resto del Carlino, 18.5.2022</li>
<li>Roberto Antolini, Arte trentina, n. 14, gennaio 2023 </li>
</ul>
<br/>

<strong>Riviste on-line:</strong>
<ul>
<li>La letteratura e noi, 26.6.2022</li>
<li>Corso Italia 7, 26.7.2022</li>
</ul>


</td>


</tr>

</table>
</div>















            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div>
    </div>
</div>


    )
  }
}
